import { writable } from 'svelte/store';
export const formDataStore = writable({});